import React, {Fragment} from "react";
import {Breadcrumbs, Paper, Typography, withStyles} from '@material-ui/core';
import autoBind from 'react-autobind';
import {participanteEntrarSessao, sessionBySlugAndParticipantQuery} from '../../graphql/Sessao';
import {Query, withApollo} from "react-apollo";
import moment from 'moment';
import {gerenciarSalasRestaurarMutation} from "../../graphql/Salas";
import {Col, Row} from "react-bootstrap";
import {withRouter} from "react-router-dom";

const styles = theme => ({
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    chronometerWrapper: {
        margin: '0 auto',
        fontSize: '32px',
        fontWeight: '500'
    },
    flexItem: {
        textAlign: 'center',
        marginTop: '30px'
    },
    countDownWraper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: "190px",
        marginLeft: '8px',
        marginRight: '8px',
    },
    countDownItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'column',
        width: '25%'
    },
    timerNumber: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "#f5b500",
        textAlign: 'center',
        fontWeight: '400',
        fontSize: '10vw',
        border: 'solid 2px #f1f1f1',
        lineHeight: '95px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '25px',
        paddingBottom: '25px',
        width: '15vw',
        height: '15vw'
    },
    timerText: {
        fontSize: '3vw',
        color: "#949491",
        fontWeight: '500',
        textAlign: 'center',
        padding: '10px',
    },
    footerMessage: {
        fontSize: '14px'
    }
});

class PartAcessarSala extends React.Component {

    constructor(props) {
        super(props);
        const {slug} = props.match.params;
        this.state = {
            slug,
            difference: null
        }
        autoBind(this);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {sessaoAndamentoUrl, slug} = this.state;
        const {history} = this.props;

        if (!prevState.sessaoAndamentoUrl && sessaoAndamentoUrl) {
            const newWindow = window.open(sessaoAndamentoUrl);
            if (!newWindow) {
                document.location.href = sessaoAndamentoUrl;
            } else {
                history.push("/part-em-andamento");
            }
        }
    }

    render() {
        const {classes} = this.props;
        return (
            <Paper className={classes.root}>
                <Row>
                    <Col>
                        {this.renderBreadCrumb()}
                    </Col>
                </Row>
                <Row>
                    <Col className={classes.chronometerWrapper}>
                        {this.loadSessionData()}
                    </Col>
                </Row>
            </Paper>
        );
    }

    renderBreadCrumb() {
        return <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
            <Typography>Participar</Typography>
            <div>Acessar sala</div>
        </Breadcrumbs>;
    }

    loadSessionData() {
        this._queryVariables = {
            slug: this.state.slug
        }

        return (
            <Query query={sessionBySlugAndParticipantQuery} variables={{...this._queryVariables}}
                   fetchPolicy='network-only'>
                {({data, loading, error, refetch}) => {
                    if (loading) return 'Carregando ...';
                    if (error) return `Error! ${error.message}`;
                    if (!data.sessionBySlugAndParticipant) return <p>Sessão não encontrada</p>;

                    const {classes} = this.props;
                    const {horaAtualQuery, sessionBySlugAndParticipant: sessionData} = data;
                    const {inicio, fim} = sessionData;

                    const momentSessionInicio = moment(inicio).utc().format();
                    const momentSessionFim = moment(fim).utc().format();

                    const horaAtual = this.state.serverTime || moment(horaAtualQuery.value).utc().format();

                    //sessao cancelada
                    if (sessionData.is_archive) {
                        return <div className={classes.flexItem}>
                            <span>A sessão <strong>{sessionData.nome}</strong> foi cancelada.</span>
                        </div>;
                    }

                    //sessao encerrada
                    if (momentSessionFim < moment(horaAtual).format()) {
                        // console.log("Encerrada");
                        return <div className={classes.flexItem}>
                            <span>A sessão <strong>{sessionData.nome}</strong> já foi encerrada.</span>
                        </div>;
                    }

                    //sessao em andamento
                    if (momentSessionInicio <= moment(horaAtual).format() && momentSessionFim > moment(horaAtual).format()) {
                        // console.log("Em andamento", { momentSessionInicio,  horaAtual: moment(horaAtual).format() });
                        return this.sessaoAndamento();
                    }

                    //sessao agendada
                    if (momentSessionInicio >= moment(horaAtual).format()) { //sessao agendada
                        // console.log("Agendada", { momentSessionInicio,  horaAtual: moment(horaAtual).format() });
                        return this.sessaoAgendada(momentSessionInicio, horaAtualQuery, sessionData);
                    }
                }}
            </Query>
        );
    }

    sessaoAgendada(sessaoDataInicio, horaAtualQuery, sessionQuery) {
        const {classes} = this.props;
        const {value: serverTime} = horaAtualQuery;

        const sessaoDataInicioUTC = moment(sessaoDataInicio).tz("UTC");
        const serverTimeUTC = moment(serverTime).tz("UTC");

        const fnDiff = () => {
            let serverTime = this.state.serverTime || serverTimeUTC;

            serverTime = serverTime.add(1, 'seconds');
            this.setState({
                serverTime
            });
        };

        if (!this.interval) {
            this.interval = setInterval(fnDiff, 1000);
            setTimeout(fnDiff, 0);
        }

        return (
            <Fragment>
                <Row>
                    <Col className={classes.flexItem}>
                        <p>{sessionQuery.nome}</p>
                        <small className={classes.footerMessage}>começará em</small>
                    </Col>
                </Row>
                <br/>
                <div className={classes.flexItem} style={{maxWidth: '65vw', margin: "auto"}}>
                    {this.renderDifference(sessaoDataInicioUTC)}
                </div>
                <div className={classes.flexItem}>
                    <small className={classes.footerMessage}>Você será redirecionado automaticamente</small>
                </div>
            </Fragment>
        );
    }

    renderDifference(inicioSessao) {
        const {classes} = this.props;
        const {serverTime} = this.state;

        const difference = moment(moment(inicioSessao) - moment(serverTime));

        const differenceDays = inicioSessao.diff(serverTime, 'days');
        const differenceHours = inicioSessao.diff(serverTime, 'hours');
        const differenceMinutes = inicioSessao.diff(serverTime, 'minutes');
        const differenceSeconds = inicioSessao.diff(serverTime, 'seconds');

        const dias = differenceDays;
        const horas = differenceHours - differenceDays * 24;
        const minutos = differenceMinutes - differenceHours * 60;
        let segundos = differenceSeconds - differenceMinutes * 60;

        if (segundos < 0)
            segundos = 0;

        return (

            <Row>
                <Col sm={12} className={classes.countDownWraper}>
                    {
                        dias
                            ? <div className={classes.countDownItem}>
                                <div className={classes.timerNumber}>{new String(dias).padStart(2, "0")}</div>
                                <div className={classes.timerText}>DIA{(dias > 1 || dias == 0) ? 'S' : ''}</div>
                            </div>
                            : null
                    }
                    {
                        horas || dias
                            ? <div className={classes.countDownItem}>
                                <div className={classes.timerNumber}>{new String(horas).padStart(2, "0")}</div>
                                <div className={classes.timerText}>HORA{(horas > 1 || horas == 0) ? 'S' : ''}</div>
                            </div>
                            : null
                    }
                    {
                        minutos || horas || dias
                            ? <div className={classes.countDownItem}>
                                <div className={classes.timerNumber}>{new String(minutos).padStart(2, "0")}</div>
                                <div className={classes.timerText}>MIN{(minutos > 1 || minutos == 0) ? 'S' : ''}</div>
                            </div>
                            : null
                    }
                    <div className={classes.countDownItem}>
                        <div className={classes.timerNumber}>{new String(segundos).padStart(2, "0")}</div>
                        <div className={classes.timerText}>SEG{(segundos > 1 || segundos == 0) ? 'S' : ''}</div>
                    </div>
                </Col>
            </Row>
        );
    }

    sessaoAndamento() {
        const {classes, client} = this.props;
        const {sessaoAndamentoUrl, slug, error, errorDetail, newWindow} = this.state;

        if (!sessaoAndamentoUrl) {
            // Apenas faz o request uma vez
            if (!this.linkRequested) {
                this.linkRequested = true;

                client.mutate({
                    mutation: participanteEntrarSessao,
                    variables: {slug}
                }).then((data) => {
                    this.setState({sessaoAndamentoUrl: data.data.participanteEntrarSessao});
                }).catch(e => {
                    let errorDetail = e;

                    try {
                        errorDetail = { message: e.graphQLErrors[0].debugMessage.split(' - /')[0] };
                    } catch(e2){

                    }

                    this.setState({error: "Erro ao acessar a sala", errorDetail: errorDetail});
                })
            }

            if (error) {
                return <div className={classes.flexItem}>
                    <p>{error}</p>
                    <p>{errorDetail ? errorDetail.message : null}</p>
                    <button onClick={
                        () => {
                            console.log("Tentar novamente");
                            this.linkRequested = false;
                            this.setState({sessaoAndamentoUrl: null, error: null, errorDetail: null });
                        }
                    }>Tentar novamente</button>
                </div>;
            }

            return <div className={classes.flexItem}>
                <span>Gerando link de acesso</span>
            </div>;
        } else {
            //Não deve chegar aqui, pois ou ele abre a popup, ou redireciona
            return <Fragment>
                <p>Redirecionando ...</p>
            </Fragment>;
        }
    }

}

export default (withStyles(styles)(withRouter(withApollo(PartAcessarSala))));